// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"SelectHitsPerPage_selectContainer__xqqkd","leftToRight":"SelectHitsPerPage_leftToRight__OQxTC"};